import { useAuth } from '@qpr/client-library';
import Login from '@qpr/user/components/Login';

const LoginPage = () => {
  const { login, auth } = useAuth();
  const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const logOnName = e.currentTarget.email.value;
    const password = e.currentTarget.password.value;

    login(logOnName, password);
  };
  return <Login handleSubmit={submitHandler} errorMessage={auth.authError} />;
};

export default LoginPage;
